import { render, staticRenderFns } from "./VerticalSlider.vue?vue&type=template&id=5c6e3640&"
import script from "./VerticalSlider.vue?vue&type=script&lang=js&"
export * from "./VerticalSlider.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VerticalSlider.vue"
export default component.exports